import escapeRegExp from 'lodash/escapeRegExp';

var WHITE_COLOR = '#fff';

/**
 * Установить cssText
 * @param  {Node}    node
 * @param  {...String} args
 */
export var setCss = function setCss(node) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    if (!node) {
        return;
    }

    if (args.length === 1) {
        node.style.cssText += args[0];
    } else {
        node.style.cssText += args.join(';');
    }
};

/**
 * Кросбраузерная проверка содержит ли узел класс
 * @param  {Node} node
 * @param  {String} cls
 * @return {Boolean}
 */
export var hasClass = function hasClass(node, cls) {
    if (!node || !cls) {
        return false;
    }

    if (node.classList && node.classList.contains) {
        return node.classList.contains(cls);
    }

    return new RegExp('\\b' + escapeRegExp(cls) + '\\b', 'i').test(node.className);
};

/**
 * Двухцветный линейный градиент
 * @param  {String} options.startColor
 * @param  {String} options.endColor
 * @return {Object}
 */
export var linearGradient = function linearGradient() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$startColor = _ref.startColor,
        startColor = _ref$startColor === undefined ? WHITE_COLOR : _ref$startColor,
        _ref$endColor = _ref.endColor,
        endColor = _ref$endColor === undefined ? WHITE_COLOR : _ref$endColor;

    return {
        backgroundImage: 'linear-gradient(to bottom, ' + startColor + ' 0%, ' + endColor + ' 100%)'
    };
};

/**
 * Вызов принудительного рефлоу лэйаута
 * @param {Node} node
 */
export var forceReflow = function forceReflow(node) {
    if (node) {
        node.offsetHeight;
    }
};